import { MoveList } from 'chessboard/model/move-list/types';

export const defaultTranslations: MoveList.Translations = {
  [MoveList.Translation.Prompt.AddComment]: () => MoveList.Translation.Prompt.AddComment,
  [MoveList.Translation.Annotations.BadMove]: () => MoveList.Translation.Annotations.BadMove,
  [MoveList.Translation.Annotations.BlackHasDecisiveAdvantage]: () =>
    MoveList.Translation.Annotations.BlackHasDecisiveAdvantage,
  [MoveList.Translation.Annotations.BlackHasModerateAdvantage]: () =>
    MoveList.Translation.Annotations.BlackHasModerateAdvantage,
  [MoveList.Translation.Annotations.BlackHasSlightAdvantage]: () =>
    MoveList.Translation.Annotations.BlackHasSlightAdvantage,
  [MoveList.Translation.Annotations.Blunder]: () => MoveList.Translation.Annotations.Blunder,
  [MoveList.Translation.Actions.ClearAllAnalysis]: () =>
    MoveList.Translation.Actions.ClearAllAnalysis,
  [MoveList.Translation.Actions.DeleteCommentAfter]: () =>
    MoveList.Translation.Actions.DeleteCommentAfter,
  [MoveList.Translation.Actions.DeleteCommentBefore]: () =>
    MoveList.Translation.Actions.DeleteCommentBefore,
  [MoveList.Translation.Actions.DeleteComment]: () => MoveList.Translation.Actions.DeleteComment,
  [MoveList.Translation.Actions.DeleteLine]: () => MoveList.Translation.Actions.DeleteLine,
  [MoveList.Translation.Actions.DeleteMove]: () => MoveList.Translation.Actions.DeleteMove,
  [MoveList.Translation.Annotations.Drawish]: () => MoveList.Translation.Annotations.Drawish,
  [MoveList.Translation.Annotations.DubiousMove]: () =>
    MoveList.Translation.Annotations.DubiousMove,
  [MoveList.Translation.Annotations.ExcellentMove]: () =>
    MoveList.Translation.Annotations.ExcellentMove,
  [MoveList.Translation.Tooltips.EnPassant]: () => MoveList.Translation.Tooltips.EnPassant,
  [MoveList.Translation.Tooltips.Stalemate]: () => MoveList.Translation.Tooltips.Stalemate,
  [MoveList.Translation.Tooltips.InsufficientMaterial]: () =>
    MoveList.Translation.Tooltips.InsufficientMaterial,
  [MoveList.Translation.Tooltips.FiftyMove]: () => MoveList.Translation.Tooltips.FiftyMove,
  [MoveList.Translation.Tooltips.WhiteTimeoutVsInsufficientMaterial]: () =>
    MoveList.Translation.Tooltips.WhiteTimeoutVsInsufficientMaterial,
  [MoveList.Translation.Tooltips.BlackTimeoutVsInsufficientMaterial]: () =>
    MoveList.Translation.Tooltips.BlackTimeoutVsInsufficientMaterial,
  [MoveList.Translation.Tooltips.DrawByAgreement]: () =>
    MoveList.Translation.Tooltips.DrawByAgreement,
  [MoveList.Translation.Annotations.GoodMove]: () => MoveList.Translation.Annotations.GoodMove,
  [MoveList.Translation.Actions.InsertCommentAfter]: () =>
    MoveList.Translation.Actions.InsertCommentAfter,
  [MoveList.Translation.Actions.InsertCommentBefore]: () =>
    MoveList.Translation.Actions.InsertCommentBefore,
  [MoveList.Translation.Actions.InsertComment]: () => MoveList.Translation.Actions.InsertComment,
  [MoveList.Translation.Actions.InsertContinuation]: () =>
    MoveList.Translation.Actions.InsertContinuation,
  [MoveList.Translation.Annotations.Miss]: () => MoveList.Translation.Annotations.Miss,
  [MoveList.Translation.Actions.MoveVariationDown]: () =>
    MoveList.Translation.Actions.MoveVariationDown,
  [MoveList.Translation.Actions.MoveVariationUp]: () =>
    MoveList.Translation.Actions.MoveVariationUp,
  [MoveList.Translation.Actions.ShowAllAnnotations]: () =>
    MoveList.Translation.Actions.ShowAllAnnotations,
  [MoveList.Translation.Actions.HideAllAnnotations]: () =>
    MoveList.Translation.Actions.HideAllAnnotations,
  [MoveList.Translation.Annotations.Novelty]: () => MoveList.Translation.Annotations.Novelty,
  [MoveList.Translation.Pieces.B]: () => MoveList.Translation.Pieces.B,
  [MoveList.Translation.Pieces.K]: () => MoveList.Translation.Pieces.K,
  [MoveList.Translation.Pieces.N]: () => MoveList.Translation.Pieces.N,
  [MoveList.Translation.Pieces.P]: () => MoveList.Translation.Pieces.P,
  [MoveList.Translation.Pieces.Q]: () => MoveList.Translation.Pieces.Q,
  [MoveList.Translation.Pieces.R]: () => MoveList.Translation.Pieces.R,
  [MoveList.Translation.Actions.Promote]: () => MoveList.Translation.Actions.Promote,
  [MoveList.Translation.Actions.RemoveAnnotation]: () =>
    MoveList.Translation.Actions.RemoveAnnotation,
  [MoveList.Translation.Actions.RemoveBegin]: () => MoveList.Translation.Actions.RemoveBegin,
  [MoveList.Translation.Actions.RemoveEnd]: () => MoveList.Translation.Actions.RemoveEnd,
  [MoveList.Translation.Actions.RemoveEvaluationAnnotation]: () =>
    MoveList.Translation.Actions.RemoveEvaluationAnnotation,
  [MoveList.Translation.Actions.RemoveFocus]: () => MoveList.Translation.Actions.RemoveFocus,
  [MoveList.Translation.Actions.SetBegin]: () => MoveList.Translation.Actions.SetBegin,
  [MoveList.Translation.Actions.SetEnd]: () => MoveList.Translation.Actions.SetEnd,
  [MoveList.Translation.Actions.SetFocus]: () => MoveList.Translation.Actions.SetFocus,
  [MoveList.Translation.Annotations.Counterplay]: () =>
    MoveList.Translation.Annotations.Counterplay,
  [MoveList.Translation.Annotations.DevelopmentLead]: () =>
    MoveList.Translation.Annotations.DevelopmentLead,
  [MoveList.Translation.Annotations.TimeTrouble]: () =>
    MoveList.Translation.Annotations.TimeTrouble,
  [MoveList.Translation.Annotations.SpeculativeMove]: () =>
    MoveList.Translation.Annotations.SpeculativeMove,
  [MoveList.Translation.Tooltips.ThreeFoldRepetition]: () =>
    MoveList.Translation.Tooltips.ThreeFoldRepetition,
  [MoveList.Translation.Annotations.PositionInZuqZwang]: () =>
    MoveList.Translation.Annotations.PositionInZuqZwang,
  [MoveList.Translation.Annotations.Unclear]: () => MoveList.Translation.Annotations.Unclear,
  [MoveList.Translation.Annotations.WhiteHasDecisiveAdvantage]: () =>
    MoveList.Translation.Annotations.WhiteHasDecisiveAdvantage,
  [MoveList.Translation.Annotations.WhiteHasModerateAdvantage]: () =>
    MoveList.Translation.Annotations.WhiteHasModerateAdvantage,
  [MoveList.Translation.Annotations.WhiteHasSlightAdvantage]: () =>
    MoveList.Translation.Annotations.WhiteHasSlightAdvantage,
  [MoveList.Translation.Annotations.WithAttack]: () => MoveList.Translation.Annotations.WithAttack,
  [MoveList.Translation.Annotations.WithCompensation]: () =>
    MoveList.Translation.Annotations.WithCompensation,
  [MoveList.Translation.Annotations.WithInitiative]: () =>
    MoveList.Translation.Annotations.WithInitiative,
  [MoveList.Translation.Plural.NumberOfDays]: (days) =>
    days === 1 ? `${days} day` : `${days} days`,
  [MoveList.Translation.Plural.NumberOfHours]: (hours) =>
    hours === 1 ? `${hours} hr` : `${hours} hrs`,
  [MoveList.Translation.Plural.NumberOfMinutes]: (minutes) =>
    minutes === 1 ? `${minutes} min` : `${minutes} mins`,
  [MoveList.Translation.GameTerminationMessages.DrawByAgreement]: () =>
    MoveList.Translation.GameTerminationMessages.DrawByAgreement,
  [MoveList.Translation.GameTerminationMessages.TimeoutVsInsufficientMaterial]: () =>
    MoveList.Translation.GameTerminationMessages.TimeoutVsInsufficientMaterial,
};
